import {Component, EventEmitter, Input, Output, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";

@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  @Input() name ?: string;
  @Output() nameChange = new EventEmitter<string>();
  @Input() email ?: string;
  @Output() emailChange = new EventEmitter<string>();
  @Input() mobilePhone ?: string;
  @Output() mobilePhoneChange = new EventEmitter<string>();
  @Input() landlinePhone ?: string;
  @Output() landlinePhoneChange = new EventEmitter<string>();
  @ViewChild('contactForm') contactForm!: NgForm;

  contactFormDirty : boolean = false;
  contactReEmail ?: string;

  constructor() {
  }

  ngOnInit(): void {
    this.contactFormDirty = false;
  }

  editFormInvalid() : boolean {
    if (this.contactForm != undefined) {
      let controls = this.contactForm.form.controls;
      for (let key in controls) {
        let control = controls[key];
        if (control.invalid && (control.touched || control.dirty))
          return true;
      }
    }
    return false;
  }

  formInvalid() : boolean {
    if (this.contactForm?.invalid)
      return true;
    return false;
  }

  markFormAsTouched() : void {
    this.contactForm.form.markAllAsTouched();
  }

  setFormDirty(dirty: boolean) {
    this.contactFormDirty = dirty;
  }

}
